module.exports = __webpack_public_path__ + "static/radikal_black-webfont-f1df970dda12968dc069626df56754ba.woff2";